import React from 'react';

import { Box, Typography } from '@mui/material';

import Image from 'src/components/image';

export interface HomeCardProps {
  onClick?: (data: any) => void;
  option: {
    imgPath: string;
    title: string;
  };
  bgColor?: any;
  textColor?: any;
  height?: string;
  width?: string;
  notLogged?: boolean;
  disabledOption?: string;
}

export default function HomeCard({
  onClick,
  option,
  bgColor,
  textColor,
  height,
  width,
  notLogged,
  disabledOption,
}: HomeCardProps) {
  const isDisabled = disabledOption === option.title;
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      sx={{
        borderRadius: 4,
        height: height ?? 120,
        width: width ?? 100,
        bgcolor: bgColor,
        opacity: notLogged || isDisabled ? 0.5 : 1,
        cursor: notLogged || isDisabled ? 'not-allowed' : 'pointer',
      }}
      onClick={!notLogged && !isDisabled ? onClick : undefined}
    >
      <Image
        src={`${option.imgPath}`}
        sx={{
          height: '80%',
          width: width ?? 100,
          borderRadius: '4px 4px 0px 0px',
          opacity: isDisabled ? 0.5 : 1,
        }}
      />
      <Typography variant="paragraphP700" p={4} color={textColor}>
        {option.title}
      </Typography>
    </Box>
  );
}
